/**
 * 品牌服务（v2.2）
 */
import { api } from './api'

export interface Brand {
  _id: string
  name: string
  logo?: string
  description?: string
  status: string
  createdAt: string
}

export interface BrandListResult {
  items: Brand[]
  total: number
  page: number
  limit: number
}

export const brandService = {
  /** 公开品牌列表（C 端首页） */
  getBrands: (page = 1, limit = 20) =>
    api.get<BrandListResult>('/brands', { page, limit }),

  getBrand: (id: string) => api.get<Brand>(`/brands/${id}`),
}
